'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to console and any error reporting service
    console.error('=== GLOBAL ERROR ===');
    console.error('Error Message:', error.message);
    console.error('Error Stack:', error.stack);
    console.error('Error Digest:', error.digest);
    console.error('Full Error:', error);
    console.error('====================');
  }, [error]);

  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
          <Card className="max-w-2xl w-full">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-red-600">
                <AlertTriangle className="h-5 w-5" />
                Application Error
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <p className="text-sm font-medium text-slate-900">
                  Something went wrong:
                </p>
                <div className="p-3 bg-red-50 border border-red-200 rounded-md">
                  <p className="text-sm text-red-800 font-mono break-words">
                    {error.message || 'An unexpected error occurred'}
                  </p>
                </div>
              </div>

              <div className="flex gap-2">
                <Button onClick={reset} variant="outline" size="sm">
                  <RefreshCw className="h-4 w-4 mr-2" />
                  Try Again
                </Button>
                <Button
                  onClick={() => (window.location.href = '/')}
                  variant="outline"
                  size="sm"
                >
                  Go Home
                </Button>
              </div>

              {error.digest && (
                <div className="pt-2 border-t">
                  <p className="text-xs text-slate-500">
                    Error ID: <span className="font-mono">{error.digest}</span>
                  </p>
                </div>
              )}

              <div className="pt-2 border-t">
                <p className="text-xs text-slate-500">
                  💡 Please report this error to the development team with the
                  Error ID above.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </body>
    </html>
  );
}
